import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/api";

export default function Login() {
  const { login, user, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && user) navigate("/gestao");
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/gestao");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha no login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0C0A09] px-5">
      <form
        onSubmit={submit}
        data-testid="login-form"
        className="w-full max-w-sm bg-[#1C1917] border border-[#292524] rounded-2xl p-8 text-stone-100"
      >
        <div className="flex flex-col items-center text-center gap-2 mb-6">
          <img src={LOGO_URL} alt="Paulista's Lanches & Pizzas" className="h-20 w-auto object-contain" />
          <div>
            <p className="font-display font-black text-xl tracking-tight">Gestão</p>
            <p className="text-xs text-stone-400">Paulista's Lanches &amp; Pizzas</p>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-stone-300">E-mail</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-[#0C0A09] border-[#292524] text-stone-100"
              placeholder="voce@email.com"
            />
          </div>
          <div>
            <Label className="text-stone-300">Senha</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#0C0A09] border-[#292524] text-stone-100"
              placeholder="••••••••"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground py-3 font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60"
        >
          <Lock className="w-4 h-4" /> {loading ? "Entrando..." : "Entrar"}
        </button>
        <a href="/" className="block text-center text-sm text-stone-400 hover:text-stone-200 mt-4 transition-colors">
          Voltar ao site
        </a>
      </form>
    </div>
  );
}
